import type { IntegrationType } from '@commenda/types';
import type { RootfiIntegrationCategory } from '@commenda/types/src/root-fi/types';

export type RootfiEnvironment = 'global' | 'dev' | 'staging';

export enum RootfiSyncStatus {
  IDLE = 'IDLE',
  FETCHING = 'FETCHING',
  SLEEPING = 'SLEEPING',
  PARSING = 'PARSING',
  RUNNING = 'RUNNING',
}

export type RootfiLinkCallbackData = {
  rootfi_id: string;
  rootfi_company_id: string;
  integration_type: IntegrationType;
  sync_status: RootfiSyncStatus;
  category: RootfiIntegrationCategory;
};

export interface RootfiLinkOptions {
  showConsentScreen?: boolean;
  environment?: RootfiEnvironment;
  onSuccess: (callbackData: RootfiLinkCallbackData) => void;
  onExit?: () => void;
}
